function LoadingComp() {
  return (
    <div
      style={{
        width: "50%",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div className="loader"></div>
    </div>
  );
}

export default LoadingComp;
